<template>
	<div class="month-calendar-wrapper">
		<el-calendar
			v-bind:value="value"
			v-on="inputListeners"
			:first-day-of-week="7"
			operations="prev-month,today,next-month"
			hide-header
			fixed-header
			ref="elCalendarRef"
		>
			<template slot="theadCell" slot-scope="{ value }">
				<span>{{ formatWeek(value) }}</span>
				<!-- <span>{{ '周' + value }}</span> -->
			</template>
			<template slot="dateCell" slot-scope="{ date, data }">
				<slot name="dateCell" :date="date" :data="data"></slot>
			</template>
		</el-calendar>
	</div>
</template>

<script>
import i18n, { EN } from '@/locales';

export default {
	computed: {
		inputListeners: function () {
			var vm = this;
			// `Object.assign` 将所有的对象合并为一个新对象
			return Object.assign(
				{},
				// 我们从父级添加所有的监听器
				this.$listeners,
				// 然后我们添加自定义监听器，
				// 或覆写一些监听器的行为
				{
					// 这里确保组件配合 `v-model` 的工作
					input: function (val) {
						vm.$emit('update:value', val);
					}
				}
			);
		}
	}
};
</script>
<script setup>
import { ref, defineExpose, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();

defineProps({
	value: {
		type: Date
	}
});

const elCalendarRef = ref();
const selectDate = type => {
	elCalendarRef.value && elCalendarRef.value.selectDate(type);
};
defineExpose({
	selectDate
});

const formatWeek = val => {
	const days = {
		'一': 'Mon',
		'二': 'Tue',
		'三': 'Wed',
		'四': 'Thu',
		'五': 'Fri',
		'六': 'Sat',
		'日': 'Sun'
	};
	if (i18n.locale === EN) {
		return days[val];
	}
	return `${proxy.$t('enterprise.datepicker.week')}${val}`;
};
</script>

<style lang="less" scoped>
.month-calendar-wrapper {
	height: 100%;
}
</style>
